import React from "react";
import ConsultationConversation from "./ConsultationConversation";
export default function ConsultationRequestDetail({

    request,
    messages = [],
    currentUser,

    reply,

    errors = {},

    loading = false,

    onReplyChange,
    onReplySubmit,
    onEdit,
    onDelete,

    onDownloadFile,
    mode,
    onBack,

}) {

    //-----------------------------------------------------

    if (!request) {

        return (

            <div className="alert alert-warning">

                Demande introuvable.

            </div>

        );

    }

    //-----------------------------------------------------

    const sender = request.sender || {};

    const canEdit =

        currentUser &&

        sender.id === currentUser.id;

    //-----------------------------------------------------

    return (

        <div className="container-fluid py-3">

            {/*==========================================*/}
            {/* HEADER                                   */}
            {/*==========================================*/}



            {/*==========================================*/}
            {/* CONVERSATION                             */}
            {/*==========================================*/}

            <ConsultationConversation

                request={request}

                messages={messages}

                currentUser={currentUser}

                reply={reply}

                errors={errors}

                loading={loading}

                onReplyChange={onReplyChange}

                onReplySubmit={onReplySubmit}

                onDownloadFile={onDownloadFile}

            />



        </div>

    );

}